import { SET_LAST_HAS_OVERLAY } from './../const';

export default (lastHasOverlay) => {
  return {
    type: SET_LAST_HAS_OVERLAY,
    lastHasOverlay: lastHasOverlay
  }
};